import amplitude from "amplitude-js";
import { getCurrentEnv } from "../utils/utils";

const initAmplitude = () => {
    let API_KEY = "a3f5a01b8a40a7d5505a48238ac81458";
    let API_KEY_TRACKING = "4479fb191724f16bfd25a9b4d1b8d0c7";

    if (getCurrentEnv() === "www") {
        API_KEY = "{AMPLITUDE_API_KEY}";
        API_KEY_TRACKING = "{AMPLITUDE_API_KEY_TRACKING}";
    }

    amplitude.getInstance().init(API_KEY);
    amplitude.getInstance().init(API_KEY_TRACKING);
};

const logAmplitudeEvent = (config = {}) => {
    const project = amplitude.getInstance();
    const event_type = config.event_type || "";
    const properties = config.properties || {};
    const setUserId = config.setUserId || "";
    const setUserProperties = config.setUserProperties || {};
    const setGroup = config.setGroup || false;
    const identify = config.identify || null;
    
    initAmplitude();
    if (typeof amplitude !== "undefined") {

        if (setUserProperties) {
            project.setUserProperties(setUserProperties);
        }

        if (setUserId) {
            project.setUserId(setUserId);
        }

        if (identify) {
            identify(amplitude);
        }

        if (setGroup) {
            project.setGroup('Organization', setGroup.groupName);
        }

        project.logEvent(event_type, properties);
    }
};

export default logAmplitudeEvent;

